export const FILTER_ALL_ID = '0';
export const FILTER_ALL_ITEM = {
  id: FILTER_ALL_ID,
  name: 'common:all'
};
